export enum PurchaseTimeframe {
  WITHIN_30_DAYS = "WITHIN_30_DAYS",
  BETWEEN_2_TO_3_MONTHS = "BETWEEN_2_TO_3_MONTHS",
  BETWEEN_3_TO_6_MONTHS = "BETWEEN_3_TO_6_MONTHS",
  MORE_THAN_6_MONTHS = "MORE_THAN_6_MONTHS",
}
